import { render, staticRenderFns } from "./pubNotice.vue?vue&type=template&id=68b0a750&scoped=true&"
import script from "./pubNotice.vue?vue&type=script&lang=js&"
export * from "./pubNotice.vue?vue&type=script&lang=js&"
import style0 from "./pubNotice.vue?vue&type=style&index=0&id=68b0a750&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b0a750",
  null
  
)

export default component.exports